<template>
  <main class="container">
    <!--  section top -->
    <section class="container__section_top">
      <!-- article left -->
      <article class="container__section_top__article_left">
        <!-- aside title -->
        <aside class="container__section_top__article_left__aside_title">
          <div class="container__section_top__article_left__aside_title__div">
            <h1 class="container__section_top__article_left__aside_title__div__h1">
              À mon sujet
            </h1>
          </div>
        </aside>
        <!--  aside text -->
        <aside class="container__section_top__article_left__aside_text">
          <div class="container__section_top__article_left__aside_text__div">
            <!--  -->
            <p class="container__section_top__article_left__aside_text__div__p_top">
              Issue d'un Bac pro en dessin industriel. J'ai par la suite poursuivi mon cursus scolaire, en effectuant
              une année de BTS également en dessin industriel.
            </p>
            <!--  -->
            <p class="container__section_top__article_left__aside_text__div__p_middle">
              Ayant comme première vocation l'envie de rejoindre l'armée. C'est ce que je fis en 2019. Par envie de
              renouveau, j'ai quitté l'armée en 2021.

            </p>
            <!--  -->
            <p class="container__section_top__article_left__aside_text__div__p_bottom">
              J'ai eu l'opportunité d'effectuer une formation en développement web.
            </p>
            <!--  -->
          </div>
        </aside>
      </article>

      <!-- ############################# -->
      <!-- Article right -->
      <!-- ############################# -->

      <article class="container__section_top__article_right">
        <aside class="container__section_top__article_right__aside_top">
          <div class="container__section_top__article_right__aside_top__div">
            <img src="@/assets/perfil_v1.jpg" alt="photo de profile"
              class="container__section_top__article_right__aside_top__div__img">
          </div>
        </aside>
        <!--  -->
        <aside class="container__section_top__article_right__aside_middle">
          <div class="container__section_top__article_right__aside_middle__div">
            <p class="container__section_top__article_right__aside_middle__div__p">
              Age : 22 ans
              <br>
              Ardèche (07)
              <br>
              Franco-suisse
            </p>
          </div>

        </aside>
        <!--  -->
        <aside class="container__section_top__article_right__aside_bottom">
          <div class="container__section_top__article_right__aside_bottom__div">
            <button class="container__section_top__article_right__aside_bottom__div__button">
              <router-link class="container__section_top__article_right__aside_bottom__div__button__router-link"
                to="/error">
                Mes realisations
              </router-link>
            </button>
          </div>
        </aside>
      </article>
    </section>

    <!--  section bottom -->

    <section class="container__section_bottom">
      <!-- article right -->
      <article class="container__section_bottom__article_left">
        <aside class="container__section_bottom__article_left__aside">
          <div class="container__section_bottom__article_left__aside__div_left">
            <a href="https://github.com/jonathandu07"
              class="container__section_bottom__article_left__aside__div_left__a">
              <img src="@/assets/github-logo.png" alt="logo github"
                class="container__section_bottom__article_left__aside__div_left__a__img">
            </a>
          </div>
          <div class="container__section_bottom__article_left__aside__div_middle">
            <a href="https://www.linkedin.com/in/jonathan-yhwh/"
              class="container__section_bottom__article_left__aside__div_middle__a">
              <img src="@/assets/linkedin.png" alt="linkedin"
                class="container__section_bottom__article_left__aside__div_middle__a__img">
            </a>
          </div>
          <div class="container__section_bottom__article_left__aside__div_right">
            <a href="https://drive.google.com/file/d/1sLzVVaHPmWRg0BOW2KNPa0h0uoAVAyi5/view?usp=sharing"
              class="container__section_bottom__article_left__aside__div_right__a">
              <h1 class="container__section_bottom__article_left__aside__div_right__a__h1">
                CV
              </h1>
            </a>
          </div>
        </aside>
      </article>

      <!-- ############################# -->
      <!-- Article right -->
      <!-- ############################# -->

      <article class="container__section_bottom__article_right">
        <!-- aside title -->
        <aside class="container__section_bottom__article_right__aside_title">
          <div class="container__section_bottom__article_right__aside_title__div">
            <h1 class="container__section_bottom__article_right__aside_title__div__h1">
              Centres d'intérêts
            </h1>
          </div>
        </aside>
        <!-- aside text -->
        <aside class="container__section_bottom__article_right__aside_text">
          <div class="container__section_bottom__article_right__aside_text__div">
            <p class="container__section_bottom__article_right__aside_text__div__p">
              Depuis mon plus jeune âge, je n'ai cessé de pratiquer du sport. Le plus récent, est la pratique du tir
              sportif.
              Aimant créer divers choses et de nature "touche à tout", je me suis intéressé à la programmation à partir
              de mes 16ans.
              La conception industriel est une des choses que j'ai pratiquer de manière précoce. Fan de l'émission "Les
              constructeurs de l'extrême". Je me plaisais à dessiner des avions et divers choses techniques.
              Naturellement je me suis tourné vers un bac pro dessin industriel.
            </p>
          </div>
        </aside>
      </article>
    </section>
  </main>

  <!-- ################################# -->

  <!-- Méthodologie -->

  <!-- ################################# -->

  <section class="section">
    <!-- article title -->
    <article class="section__article_title">
      <aside class="section__article_title__aside">
        <!-- div vide -->
        <div class="section__article_title__aside__div_vide1">

        </div>
        <!-- div title -->
        <div class="section__article_title__aside__div">
          <h1 class="section__article_title__aside__div__h1">
            Méthodologie
          </h1>
        </div>
        <!-- div vide -->
        <div class="section__article_title__aside__div_vide2">

        </div>
      </aside>
    </article>

    <!-- article body -->
    <!-- display grid-->
    <article class="section__article_body">
      <!-- aside 1 left hight -->
      <aside class="section__article_body__aside_1">
        <div class="section__article_body__aside_1__div">
          <p class="section__article_body__aside_1__div__p">
            Des sites web responsives, adaptatifs, et flexibles. Il me tient à cœur de réaliser des sites web design,
            optimisés et fidèles aux désirs du client.
          </p>
        </div>
      </aside>
      <!-- aside 2 right hight -->
      <aside class="section__article_body__aside_2">
        <div class="section__article_body__aside_2__div">
          <img src="@/assets/responsive.png" alt="responsive" class="section__article_body__aside_2__div__img" />
        </div>
      </aside>
      <!-- aside 3 left bottom -->
      <aside class="section__article_body__aside_3">
        <!-- display grid -->
        <div class="section__article_body__aside_3__div_1">
          <img src="@/assets/psd_file.png" alt="photoshop logo" class="section__article_body__aside_3__div_1__img" />
        </div>

        <div class="section__article_body__aside_3__div_2">
          <img src="@/assets/adobe_illustrator.png" alt=" ilustrator logo"
            class="section__article_body__aside_3__div_2__img">
        </div>

        <div class="section__article_body__aside_3__div_3">
          <img src="@/assets/adobe_xd.png" alt="adobe xd logo" class="section__article_body__aside_3__div_3__img">
        </div>

        <div class="section__article_body__aside_3__div_4">
          <img src="@/assets/adobe_indesign.png" alt="Indesign logo" class="section__article_body__aside_3__div_4__img">
        </div>
      </aside>
      <!-- aside 4 right bottom -->
      <aside class="section__article_body__aside_4">
        <!-- div top -->
        <div class="section__article_body__aside_4__div_top">
          <p class="section__article_body__aside_4__div_top__p">
            Pour être au plus proche des besoins du clients, j'utilise les outils suivant : Photoshop, Illustrator,
            Adobe
            XD et In Design.
          </p>
        </div>
        <!-- div bottom -->
        <div class="section__article_body__aside_4__div_bottom">
          <p class="section__article_body__aside_4__div_bottom__p">
            Également je me tient à jours des nouveautés.
          </p>
        </div>
      </aside>
    </article>
  </section>
</template>

<script>
export default {
  name: 'AproposDesktop'
}
</script>

<style  lang=scss scoped>
@import "@/style/components/Apropos/AproposDesktop.scss";

@media screen and(max-width: 926px) {
  .container {
    display: none;
  }

    .section {
      display: none;
    }
}


</style>
